import { isCategoryActive } from './categoryUtils';

/** Produit actif sauf si is_active est explicitement false (rétrocompatibilité). */
export const isProductActive = (product) => product?.is_active !== false;

/**
 * Visible dans les listes dynamiques : produit actif et catégorie parente active.
 */
export const isProductVisibleInLists = (product, categories) => {
  if (!product || !isProductActive(product)) return false;
  const categoryId = product.category_id;
  if (!categoryId) return true;
  const category = (categories || []).find((c) => c.id === categoryId);
  return category ? isCategoryActive(category) : false;
};

export const filterProductsForDynamicLists = (products, categories) =>
  (products || []).filter((p) => isProductVisibleInLists(p, categories));

/** Produits pour liste dynamique ; conserve la sélection courante si invisible (édition). */
export const getProductsForSelect = (
  products,
  categories,
  { categoryId = null, selectedProductId = null } = {},
) => {
  let list = filterProductsForDynamicLists(products, categories);
  if (categoryId) {
    list = list.filter((p) => p.category_id === categoryId);
  }
  if (selectedProductId && !list.some((p) => p.id === selectedProductId)) {
    const current = (products || []).find((p) => p.id === selectedProductId);
    if (current) list = [...list, current];
  }
  return list;
};

export const getProductOptionsForSelect = (products, categories, opts) =>
  getProductsForSelect(products, categories, opts).map((p) => ({
    value: p.id,
    label: p.name,
  }));
